import React from 'react';
import { Calendar } from 'lucide-react';

const MatriculaDatos = ({ matricula }) => {
  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    return date.toLocaleDateString();
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center">
        <Calendar className="mr-2 text-indigo-500" size={20} />
        Estado de Matrícula
      </h3>
      <div className="space-y-3">
        <div>
          <span className="text-sm font-medium text-gray-500">Estado:</span>
          <span className={`px-3 py-1 inline-flex text-xs leading-5 font-medium rounded-full ml-2
            ${matricula.matricula.estado === 'Activa' 
              ? 'bg-emerald-50 text-emerald-700' 
              : 'bg-rose-50 text-rose-700'}`}>
            {matricula.matricula.estado || 'Pendiente'}
          </span>
        </div>
        <div>
          <span className="text-sm font-medium text-gray-500">Fecha de Matrícula:</span>
          <p className="text-gray-900">
            {matricula.matricula.fecha_matricula ? formatearFecha(matricula.matricula.fecha_matricula) : 'No disponible'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MatriculaDatos;
